import { Injectable } from '@angular/core';

@Injectable()
export class GlobalVariable {
    userToken: string = null;
    mainMenuVisiable = true ;
    User: any = []; }
